const region = [
  { value: 1, label: 'NO' },
  { value: 2, label: 'NE' },
  { value: 3, label: 'CN' },
  { value: 4, label: 'SE' },
  { value: 5, label: 'SU' },
];

export default region;
